/* crossout-word (TSR3, perf-2026-09-08): the one-time crossout animation for every .cxo instance
   (PDP ticker + home hero H1). The first word (ATHLETE'S) is painted synchronously before first
   paint by the inline script in snippets/crossout-word.liquid; this file runs the SEQUENCE when the
   instance scrolls into view:
     1. draw the strike across LIFTER'S,
     2. type the companion line ([data-cxo-typed] in the same <section>, e.g. "for everyone." after
        POUCH.) one char at a time (~40ms), caret blinks then settles,
     3. HOLD. No rotation by default.
   Rotation is retained but OFF unless data-cxo-interval > 0 (the interval is a setting defaulting to
   0), so it can be re-enabled without code. Reduced motion / no-JS = static struck LIFTER'S +
   ATHLETE'S + the full typed line, no animation. Pauses off-screen and on body.site-motion-paused.
   Per-instance + global init guards. */
(function () {
  if (window.__thruxCxoInit) return;
  window.__thruxCxoInit = true;

  var reduceMQ = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var REDUCE = !!(reduceMQ && reduceMQ.matches);
  var TYPE_STEP = 40;   // ms per character
  var FADE = 260;       // ink-word swap fade (rotation only)

  function initOne(root) {
    if (root.dataset.cxoReady) return;
    root.dataset.cxoReady = '1';
    var aboveEl = root.querySelector('[data-cxo-above]');
    var strike = root.querySelector('.cxo-strike');
    var words = [], ink = {};
    try { words = JSON.parse(root.querySelector('[data-cxo-words]').textContent) || []; } catch (e) {}
    try { ink = JSON.parse(root.querySelector('[data-cxo-ink]').textContent) || {}; } catch (e) {}
    if (!aboveEl) return;
    var interval = parseInt(root.getAttribute('data-cxo-interval'), 10) || 0;   // 0 = rotation off
    var rotates = interval > 0 && words.length >= 2;
    var i = 0;

    function renderWord(w) {
      if (ink[w]) {
        aboveEl.textContent = '';
        aboveEl.style.setProperty('--ink', 'url("' + ink[w] + '")');
        aboveEl.setAttribute('role', 'img');
        aboveEl.setAttribute('aria-label', w);
        aboveEl.classList.add('cxo-above--ink');
        aboveEl.classList.remove('cxo-above--text');
      } else {
        aboveEl.style.removeProperty('--ink');
        aboveEl.removeAttribute('role');
        aboveEl.removeAttribute('aria-label');
        aboveEl.classList.add('cxo-above--text');
        aboveEl.classList.remove('cxo-above--ink');
        aboveEl.textContent = w;
      }
    }
    // The inline before-paint script already painted words[0]; only paint here if it did not run.
    if (!aboveEl.classList.contains('cxo-above--ink') && !aboveEl.classList.contains('cxo-above--text') && words[0]) renderWord(words[0]);
    if (strike && !REDUCE) strike.classList.add('is-armed');

    var killed = false;

    // ---- typewriter: the section's [data-cxo-typed] line (ghost reserves size, live overlays) ----
    function runTyped(done) {
      var sec = root.closest ? root.closest('section') : null;
      var host = sec ? sec.querySelector('[data-cxo-typed]') : null;
      if (!host || host.dataset.cxoTypedReady) { if (done) done(); return; }
      host.dataset.cxoTypedReady = '1';
      var ghost = host.querySelector('.cxo-typed-ghost');
      var full = (ghost ? ghost.textContent : host.textContent) || '';
      if (REDUCE) { if (ghost) ghost.style.visibility = 'visible'; if (done) done(); return; }
      var live = document.createElement('span');
      live.className = 'cxo-typed-live';
      live.setAttribute('aria-hidden', 'true');
      host.appendChild(live);
      host.classList.add('cxo-typed--caret');
      var n = 0;
      (function typeChar() {
        if (killed) return;
        if (n <= full.length) { live.textContent = full.slice(0, n); n++; setTimeout(typeChar, TYPE_STEP); }
        else {
          setTimeout(function () {
            if (killed) return;
            host.classList.remove('cxo-typed--caret');
            if (ghost) ghost.style.visibility = 'visible'; // settle into the in-flow text
            live.parentNode && live.parentNode.removeChild(live);
          }, 900);
          if (done) done();
        }
      })();
    }

    // reduced motion: static struck base + first word + full typed line, no animation
    if (REDUCE) { runTyped(); return; }

    var timer = null, visible = false, drew = false, started = false;
    function paused() { return killed || document.hidden || !visible || document.body.classList.contains('site-motion-paused'); }
    function schedule(ms) { clearTimeout(timer); timer = setTimeout(tick, ms); }
    function tick() {
      if (paused()) { schedule(600); return; }
      aboveEl.classList.add('is-swapping');
      setTimeout(function () {
        if (killed) return;
        i = (i + 1) % words.length;
        renderWord(words[i]);
        void aboveEl.offsetWidth;
        aboveEl.classList.remove('is-swapping');
        schedule(interval);
      }, FADE);
    }
    function start() {
      if (started) return; started = true;
      if (strike && !drew) { drew = true; strike.classList.add('is-drawn'); }
      runTyped(function () { if (rotates) schedule(interval); });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (e) { visible = e[0].isIntersecting; if (visible) start(); else if (rotates) clearTimeout(timer); }, { threshold: 0.25 });
      io.observe(root);
    } else { visible = true; start(); }
    document.addEventListener('click', function (e) { if (rotates && e.target && e.target.closest && e.target.closest('.motion-toggle')) { if (!paused()) schedule(400); } }, true);
    document.addEventListener('shopify:section:unload', function (e) { if (root && e.target && e.target.contains && e.target.contains(root)) { killed = true; clearTimeout(timer); } });
  }

  function initAll() { document.querySelectorAll('.cxo[data-cxo]').forEach(initOne); }
  if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
